module.exports = __webpack_public_path__ + "static/media/downa-rrow-dis.e55975ab.svg";